import { ContestEntry } from '@/modules/ContestFormModule/ContestForm/ContestForm.types';
import ApiService from '@/common/ApiService/ApiService';
import { HttpVerb } from '@/common/ApiService/HttpVerb';
import { AxiosResponse } from 'axios';

const EmailSignUpService = new ApiService('/api/CommonService/', {
  showLoading: true,
});

export const submitContest = (model: ContestEntry): Promise<any> => {
  return EmailSignUpService.call('SendContestRequest', model, {
    verb: HttpVerb.POST,
    returnData: false,
  }).then((res: AxiosResponse) => {
    if (res.status == 200) {
      return { IsOk: true, Item: res.data, Error: null };
    }
    return { IsOk: false, Item: null, Error: res.data };
  });
};
